import * as React from 'react'

export interface SelectContext {
  size: 'sm' | 'md'
  variant: 'ghost' | 'outline'
}

export const SelectContext = React.createContext<SelectContext | null>(null)

export function useSelectContext() {
  const context = React.useContext(SelectContext)
  if (!context) {
    throw new Error('useSelectContext must be used within a SelectProvider')
  }
  return context
}
